var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangulo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_22",
    "data-name": "Grupo 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.926,
    height: 57.716,
    viewBox: "0 0 69.926 57.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_35",
    "data-name": "Trazado 35",
    d: "M0-40.911H69.926V-98.627H0Z",
    transform: "translate(0 98.627)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_34",
    "data-name": "Trazado 34",
    d: "M-35.435-39.03A17.263,17.263,0,0,0-18.158-56.279,17.263,17.263,0,0,0-35.435-73.528a17.239,17.239,0,0,0-6.966,1.46l-1.586-2.194a19.886,19.886,0,0,1,8.553-1.919A19.919,19.919,0,0,1-15.5-56.279a19.919,19.919,0,0,1-19.935,19.9,19.941,19.941,0,0,1-18.8-13.269H-84.6c-.74,0-1.042-.507-.67-1.138L-60.027-93.62a.712.712,0,0,1,1.341,0l25.239,42.837c.37.628.074,1.138-.67,1.138H-46.885V-52.3h9.456L-59.356-89.45-81.285-52.3h28.861l1.038,2.7A17.324,17.324,0,0,0-35.435-39.03",
    transform: "translate(85.426 94.092)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangulo);
export default __webpack_public_path__ + "static/media/Triangulo.cb74b746341333d8b445a14207f25a85.svg";
export { ForwardRef as ReactComponent };